import { render, staticRenderFns } from "./QrcodeCover.vue?vue&type=template&id=38b07928&scoped=true&lang=html"
import script from "./QrcodeCover.vue?vue&type=script&lang=js"
export * from "./QrcodeCover.vue?vue&type=script&lang=js"
import style0 from "./QrcodeCover.vue?vue&type=style&index=0&id=38b07928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b07928",
  null
  
)

export default component.exports